// Two palettes, same shape, same hues — only lightness/contrast changes
// between them. The sidebar color is deliberately NOT part of either
// palette's mode-dependent values below (see components.js): it stays
// #12131C in both light and dark mode.

export const lightPalette = {
  mode: 'light',
  primary: { main: '#4F46E5', light: '#818CF8', dark: '#3730A3', contrastText: '#FFFFFF' },
  secondary: { main: '#B4552C', light: '#D97F57', dark: '#8A3F1F', contrastText: '#FFFFFF' },
  success: { main: '#1E8E5A', light: '#34D399', dark: '#0F6B41', contrastText: '#FFFFFF' },
  error: { main: '#C0392B', light: '#F0685F', dark: '#962A20', contrastText: '#FFFFFF' },
  warning: { main: '#B7791F', light: '#F5B94D', dark: '#8A5C15', contrastText: '#FFFFFF' },
  info: { main: '#2563EB', light: '#60A5FA', dark: '#1D4ED8', contrastText: '#FFFFFF' },
  grey: {
    50: '#F7F8FC', 100: '#F0F2F9', 200: '#E3E6F0', 300: '#C9CEE0',
    400: '#A6ABC2', 500: '#8A8FA3', 600: '#5B6072', 700: '#3F4356',
    800: '#262A3B', 900: '#14161F',
  },
  background: { default: '#E7E9F5', paper: '#FFFFFF', sidebar: '#1B1F3B' },
  text: { primary: '#14161F', secondary: '#5B6072', disabled: '#A6ABC2' },
  divider: '#E3E6F0',

  platformColors: {
    facebook: '#1877F2', instagram: '#E1306C', twitter: '#111111', x: '#111111',
    linkedin: '#0A66C2', youtube: '#FF0000', tiktok: '#010101', pinterest: '#E60023',
    threads: '#010101', bluesky: '#0A7AFF', google_business: '#4285F4',
    google_ads: '#34A853', web_page: '#607D8B', blog: '#78909C', quora: '#B92B27',
  },
  statusColors: {
    draft: '#5B6072', scheduled: '#B7791F', published: '#1E8E5A',
    failed: '#C0392B', cancelled: '#8A8FA3', in_review: '#7C3AED', approved: '#1E8E5A', rejected: '#C0392B',
  },
};

export const darkPalette = {
  mode: 'dark',
  primary: { main: '#818CF8', light: '#A5AEFB', dark: '#4F46E5', contrastText: '#0B0C14' },
  secondary: { main: '#D97F57', light: '#E8A47E', dark: '#B4552C', contrastText: '#0B0C14' },
  success: { main: '#34D399', light: '#6EE7B7', dark: '#1E8E5A', contrastText: '#0B0C14' },
  error: { main: '#F87171', light: '#FCA5A5', dark: '#C0392B', contrastText: '#0B0C14' },
  warning: { main: '#FBBF24', light: '#FCD34D', dark: '#B7791F', contrastText: '#0B0C14' },
  info: { main: '#60A5FA', light: '#93C5FD', dark: '#2563EB', contrastText: '#0B0C14' },
  grey: {
    50: '#1B1E29', 100: '#242836', 200: '#363B4C', 300: '#4A4F63',
    400: '#666B80', 500: '#82869C', 600: '#9BA0B4', 700: '#C9CEE0',
    800: '#E4E6EF', 900: '#F3F4F8',
  },
  background: { default: '#101218', paper: '#181A22', sidebar: '#1B1F3B' },
  text: { primary: '#F3F4F8', secondary: '#9BA0B4', disabled: '#666B80' },
  divider: '#363B4C',

  platformColors: {
    facebook: '#4C93F8', instagram: '#F05C8D', twitter: '#E4E6EF', x: '#E4E6EF',
    linkedin: '#4C9BE8', youtube: '#FF5C5C', tiktok: '#E4E6EF', pinterest: '#F0475C',
    threads: '#E4E6EF', bluesky: '#4DA3FF', google_business: '#6FA3F7',
    google_ads: '#5FC584', web_page: '#8FA3B0', blog: '#9DAEB8', quora: '#E0605C',
  },
  statusColors: {
    draft: '#9BA0B4', scheduled: '#FBBF24', published: '#34D399',
    failed: '#F87171', cancelled: '#82869C', in_review: '#A78BFA', approved: '#34D399', rejected: '#F87171',
  },
};

// Back-compat default export — existing imports of `palette` keep working
// and get the light palette, matching the app's current behavior.
export const palette = lightPalette;
